import { z } from "zod";

const ASSET_CATEGORIES = ["barrier", "dugout", "pavilion", "jersey", "other"] as const;

export const createAssetTypeSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  description: z.string().max(1000).nullable().optional(),
  category: z.enum(ASSET_CATEGORIES, { message: "Invalid category" }),
  width_mm: z.number().int().min(1, "Width must be positive"),
  height_mm: z.number().int().min(1, "Height must be positive"),
  depth_mm: z.number().int().min(1).nullable().optional(),
  silhouette: z.string().max(50).nullable().optional(),
});

export const updateAssetTypeSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  description: z.string().max(1000).nullable().optional(),
  category: z.enum(ASSET_CATEGORIES, { message: "Invalid category" }).optional(),
  width_mm: z.number().int().min(1, "Width must be positive").optional(),
  height_mm: z.number().int().min(1, "Height must be positive").optional(),
  depth_mm: z.number().int().min(1).nullable().optional(),
  silhouette: z.string().max(50).nullable().optional(),
});

export const createAssetTypeAdSpaceSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  width_mm: z.number().int().min(1, "Width must be positive"),
  height_mm: z.number().int().min(1, "Height must be positive"),
  offset_x_mm: z.number().int().default(0),
  offset_y_mm: z.number().int().default(0),
  sort_order: z.number().int().min(0).default(0),
});

export const updateAssetTypeAdSpaceSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  width_mm: z.number().int().min(1).optional(),
  height_mm: z.number().int().min(1).optional(),
  offset_x_mm: z.number().int().optional(),
  offset_y_mm: z.number().int().optional(),
  sort_order: z.number().int().min(0).optional(),
});

export type CreateAssetTypeInput = z.infer<typeof createAssetTypeSchema>;
export type UpdateAssetTypeInput = z.infer<typeof updateAssetTypeSchema>;
export type CreateAssetTypeAdSpaceInput = z.infer<typeof createAssetTypeAdSpaceSchema>;
export type UpdateAssetTypeAdSpaceInput = z.infer<typeof updateAssetTypeAdSpaceSchema>;
